<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          ref="teamGroupCodeRef"
          slot="teamGroupCode"
          :value.sync="queryParams.teamGroupCode"
          selectType="selectAssembleSearch"
          assembleLabel
          searchParam="teamName"
          focusGet
          requestApi="/bom/team/list"
          :selectItem="{ value: 'teamCode', label: 'teamName' }"
          :setParams="{ organizationCode: organizationCodeOrigin }"
        />
        <global-select
          slot="businessType"
          selectType="selectFilter"
          v-model="queryParams.businessType"
          :dropdown-match-select-width="false"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'MES_MO_CC_TYPE' }"
        />
        <global-select
          slot="transactionType"
          selectType="selectFilter"
          :value.sync="queryParams.transactionType"
          :selectData="transactionTypeList"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvProductionOperationReportExport" ref="download" />
        <a-button type="primary" @click="handleExport" v-hasPermi="['inv:invProductionOperationReport:listExport']">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" rowKey="id"
                      :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import { mapState } from 'vuex';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import { apiInvProductionOperationReportList, apiInvProductionOperationReportExport } from '@/api/report/ordinary-report'
import moment from 'moment'
export default {
  name: 'ProductionOperationReport',
  components: { DownloadModal },
  data() {
    return {
      apiInvProductionOperationReportExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiInvProductionOperationReportList, false),
        pageCurrent: true
      },
      transactionTypeList: [], // 操作内容
      // 查询参数
      queryParams: {
        moTicketCode: undefined,
        orderNo: undefined,
        transactionType: undefined,
        transactionDate: undefined,
        transactionDateStart: undefined,
        transactionDateEnd: undefined,
        operatorAccount: undefined,
        operatorName: undefined,
        businessType: undefined,
        teamGroupCode: undefined
      },
      formList: [
        { label: 'MO票号', decorator: ['moTicketCode'], type: 'input' },
        { label: '计划单号', decorator: ['orderNo'], type: 'input' },
        { label: '操作内容', decorator: ['  transactionType'], type: 'transactionType' },
        {
          label: '操作时间',
          type: 'range',
          decorator: ['transactionDate'],
          disposeFormat: {
            transactionDateStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            transactionDateEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '操作人账号', decorator: ['operatorAccount'], type: 'input' },
        { label: '操作人姓名', decorator: ['operatorName'], type: 'input' },
        { label: '业务类型', decorator: ['businessType'], type: 'businessType' },
        { label: '班组', decorator: ['  teamGroupCode'], type: 'teamGroupCode' }
      ],
      // 表格字段
      columns: [
        { title: '业务类型', dataIndex: 'businessTypeName', align: 'center', width: 100 },
        { title: '班组', dataIndex: 'teamGroupName', align: 'center', width: 100 },
        { title: 'MO号', dataIndex: 'wipEntityName', align: 'center', width: 160 },
        { title: 'MO票号', dataIndex: 'moTicketCode', align: 'center', width: 120 },
        { title: '计划单号', dataIndex: 'orderNo', align: 'center', width: 140 },
        { title: '父工单号', dataIndex: 'upstreamWorkNumber', align: 'center', width: 160 },
        { title: '物料编码', dataIndex: 'assemblyItemCode', align: 'center', width: 170 },
        { title: '物料名称', dataIndex: 'assemblyItemName', align: 'center', width: 160 },
        { title: '操作内容', dataIndex: 'transactionTypeName', align: 'center', width: 160 },
        { title: '操作时间', dataIndex: 'transactionDate', align: 'center', width: 140 },
        { title: '操作数量', dataIndex: 'transactionQty', align: 'center', width: 80 },
        { title: '操作人账号', dataIndex: 'operatorAccount', align: 'center', width: 90 },
        { title: '操作人员编码', dataIndex: 'operatorCode', align: 'center', width: 100 },
        { title: '姓名', dataIndex: 'operatorName', align: 'center', width: 90 }
      ]
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  mounted() {
    this.getLookupList()
    this.$refs.refSearchForm.form.setFieldsValue({ transactionDate: [moment(), moment()] })
    this.onSearch(
      {
        transactionDateStart: moment().format('YYYY-MM-DD 00:00:00'),
        transactionDateEnd: moment().format('YYYY-MM-DD 23:59:59')
      }
    )
  },
  methods: {
    // 获取lookup数据
    getLookupList () {
      this.transactionTypeList = []
      const lookupQueryParams = {
        lookupType: 'MES_DOCUMENT_TYPE',
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(res => {
        this.transactionTypeList = res?.rows || [];
        this.transactionTypeList = this.transactionTypeList.filter(item => item.attribute1 === 'Y')
      })
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        moTicketCode: undefined,
        orderNo: undefined,
        transactionType: undefined,
        transactionDate: undefined,
        transactionDateStart: undefined,
        transactionDateEnd: undefined,
        operatorAccount: undefined,
        operatorName: undefined,
        businessType: undefined,
        teamGroupCode: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      if(this.$refs?.teamGroupCodeRef) this.$refs.teamGroupCodeRef.handleSearch()
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
